// libs
import { useApolloClient } from 'hooks/useApolloClient'
// types
import {
  IRiskResponse,
  IRiskCreateInput,
  IRiskUpdateInput,
  IMutationResponse,
  IRiskDeleteMutationArgs,
  IRiskUpdateMutationArgs,
  IRiskCreateMutationArgs,
  IRiskCreatePublicMutationArgs
} from 'types/graphql'
// graphql
import {
  RISK_CREATE_MUTATION,
  RISK_DELETE_MUTATION,
  RISK_UPDATE_MUTATION,
  RISK_CREATE_PUBLIC_MUTATION
} from 'graphql/risk/mutations'
// utils
import { handleError } from 'utils/errors/handlers'

export const useRisksAPI = () => {
  const { client } = useApolloClient()

  const createRisk = async (input: IRiskCreateInput) => {
    try {
      const response = await client.mutate<Record<'riskCreate', IRiskResponse>, IRiskCreateMutationArgs>({
        mutation: RISK_CREATE_MUTATION,
        variables: {
          input
        }
      })

      return response.data.riskCreate.data
    } catch (e) {
      handleError(e, 'useRisksAPI.createRisk')
    }
  }

  const createPublicRisk = async (variables: { domain: string; input: IRiskCreateInput }, accessToken: string) => {
    try {
      const response = await client.mutate<Record<'riskCreatePublic', IRiskResponse>, IRiskCreatePublicMutationArgs>({
        mutation: RISK_CREATE_PUBLIC_MUTATION,
        variables,
        context: {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      })

      return response.data.riskCreatePublic.data
    } catch (e) {
      handleError(e, 'useRisksAPI.createPublicRisk')
    }
  }

  const updateRisk = async (id: string, input: IRiskUpdateInput) => {
    await client.mutate<IMutationResponse, IRiskUpdateMutationArgs>({
      mutation: RISK_UPDATE_MUTATION,
      variables: {
        id,
        input
      }
    })
  }

  const deleteRisk = async (id: string) => {
    await client.mutate<IMutationResponse, IRiskDeleteMutationArgs>({
      mutation: RISK_DELETE_MUTATION,
      variables: {
        id
      }
    })
  }

  return {
    createRisk,
    updateRisk,
    deleteRisk,
    createPublicRisk
  }
}
